<template>
  <b-row class="match-height">
    <b-col cols="12">
      <b-card :title="this.$route.meta.title">
        <b-alert
          v-height-fade
          dismissible
          v-model="showDismissibleAlert"
          fade
          class="mb-2"
          variant="danger"
          v-id="showDismissibleAlert == true"
        >
          <div class="alert-body">
            <span>{{ messages }}</span>
          </div>
        </b-alert>
        <ValidationObserver v-slot="{ handleSubmit }">
          <b-form @submit.prevent="handleSubmit(save)">
            <b-row>
              <b-col md="3">
                <ValidationProvider
                  name="Description"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-form-group>
                    <label for="textarea-auto-height">Bahasa</label>
                    <select class="form-control" v-model="model.lang">
                      <option value="id">Indonesia</option>
                      <option value="en">English</option>
                    </select>
                  </b-form-group>
                  <p class="fs-6 text-danger">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <ValidationProvider
                  name="Judul"
                  rules="required|max:200"
                  :custom-messages="{ max: 'Judul maksimal 200 karakter.' }"
                  v-slot="{ errors }"
                >
                  <b-form-group label="Judul" label-for="mc-name">
                    <b-form-input
                      id="mc-name"
                      placeholder="Masukkan Judul"
                      v-model="model.title"
                    />

                    <p class="fs-6 text-danger">
                      {{ errors[0] }}
                    </p>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
            </b-row>
            <b-row v-for="(i, index) in model.data.sections" :key="index">
              <b-col md="12">
                <ValidationProvider
                  name="Judul Section"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-form-group label="Judul Section" label-for="mc-name">
                    <b-form-input
                      id="mc-name"
                      placeholder="Masukkan Judul Section"
                      v-model="model.data.sections[index].title"
                    />

                    <p class="fs-6 text-danger">
                      {{ errors[0] }}
                    </p>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col md="12">
                <ValidationProvider
                  name="Deskripsi"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="textarea-auto-height">Deskripsi </label>
                  <quill-editor
                    v-model="model.data.sections[index].description"
                    :options="editorOption"
                  >
                  </quill-editor>

                  <p class="fs-6 text-danger">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>
              </b-col>

              <b-col md="6" class="mb-2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  @click="addSection"
                  variant="primary"
                  class="mr-1 float-left"
                >
                  Tambah Section
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  @click="removeSection(index)"
                  variant="danger"
                  class="float-left"
                  v-if="model.data.sections.length > 1"
                >
                  Hapus Section
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <ValidationProvider
                  name="Status"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-form-group label="Status" label-for="mc-status">
                    <b-form-radio-group
                      v-model="model.status"
                      :options="statusList"
                      class="mt-1"
                      value-field="value"
                      text-field="label"
                    />
                    <p class="fs-6 text-danger">
                      {{ errors[0] }}
                    </p>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
            </b-row>
            <b-card-footer>
              <!-- submit and reset -->
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1 float-right"
              >
                Simpan
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                class="mr-1 float-right"
                variant="outline-secondary"
                :to="{ name: 'static-pages' }"
              >
                Batal
              </b-button>
            </b-card-footer>
          </b-form>
        </ValidationObserver>
      </b-card>
    </b-col>
  </b-row>
</template>

<style>
.ql-container {
  height: 200px !important;
}
</style>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormFile,
  BFormCheckbox,
  BForm,
  BButton,
  BCard,
  BCardFooter,
  BFormRadioGroup,
  BFormInvalidFeedback,
  BFormValidFeedback,
  BFormTextarea,
  BAlert,
  BImg,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import axios from "@axios";
import { heightFade } from "@core/directives/animations";
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    BCard,
    BCardFooter,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormCheckbox,
    BForm,
    BButton,
    BFormRadioGroup,
    vSelect,
    BFormInvalidFeedback,
    BFormValidFeedback,
    BFormTextarea,
    BAlert,
    BImg,
    quillEditor,
  },
  directives: {
    Ripple,
    "height-fade": heightFade,
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: [
            [{ font: [] }, { size: [] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ script: "super" }, { script: "sub" }],
            // [{ header: "1" }, { header: "2" }, "blockquote", "code-block"],
            [{ header: "1" }, { header: "2" }],
            [
              { list: "ordered" },
              { list: "bullet" },
              // { indent: "-1" },
              // { indent: "+1" },
            ],
            // ["direction", { align: [] }],
            [{ align: [] }],
            ["clean"],
            ["link"],
          ],
        },
        theme: "snow",
        placeholder: "Deskripsi",
      },
      name: "UsersForm",
      errors: {},
      showDismissibleAlert: false,
      config: {
        api: "/content",
        redirect: "static-pages",
      },
      model: {
        title: null,
        data: { sections: [{ title: null, description: null }] },
        lang: "id",
        type: "page",
      },

      statusList: [
        {
          label: "Aktif",
          value: "active",
        },
        {
          label: "Tidak Aktif",
          value: "inactive",
        },
      ],
      messages: "",
    };
  },
  mounted() {
    let _ = this;
    _.getData();
  },
  methods: {
    addSection() {
      let _ = this;
      _.model.data.sections.push({
        title: null,
        description: null,
      });
    },
    removeSection(index) {
      this.model.data.sections.splice(index, 1);
    },
    getData() {
      let _ = this;
      if (this.$route.meta.action == "edit") {
        axios
          .get(_.config.api + "/" + this.$route.params.id)
          .then((response) => {
            let _ = this;
            _.model = response.data.data;
          });
      }
    },

    save() {
      let _ = this;
      if (this.$route.meta.action == "store") {
        console.log(_.model);
        axios
          .post(_.config.api, _.model)
          .then((res) => {
            _.$router.push({
              name: _.config.redirect,
              params: {
                event: "success",
                title: "Create Success",
                text: res.data.message,
              },
            });
          })
          .catch((e) => {
            let vm = this;
            vm.showDismissibleAlert = true;
            if (typeof e.response.data.message === "object") {
              vm.messages = e.response.data.message.errors[0].msg;
            } else {
              vm.messages = e.response.data.message;
            }
          });
      } else {
        _.model.id = _.$route.params.id;

        let data = {
          title: _.model.title,
          status: _.model.status,
          type: "page",
          data: _.model.data,
          lang: _.model.lang,
        };
        axios
          .put(_.config.api + "/" + _.$route.params.id, data)
          .then((res) => {
            _.$router.push({
              name: _.config.redirect,
              params: {
                event: "success",
                title: "Update About Us Success",
                text: res.data.message,
              },
            });
          })
          .catch((e) => {
            let vm = this;
            vm.showDismissibleAlert = true;
            if (typeof e.response.data.message === "object") {
              vm.messages = e.response.data.message.errors[0].msg;
            } else {
              vm.messages = e.response.data.message;
            }
          });
      }
    },
  },
};
</script>
